import { ROLES_ID } from "./roles";

export const GET_ALL_BUSINESS = [
    ROLES_ID.ADMIN,
    ROLES_ID.SU_ADMIN,
    ROLES_ID.TECHNICIAN,

]

export const PRINT_STICKER = [
    ROLES_ID.SU_ADMIN,
    ROLES_ID.INVENTORY,
]

export const PRINT_MC_NAME = [
    ROLES_ID.SU_ADMIN,
    ROLES_ID.INVENTORY,
]

export const UPDATE_MC_SOFTWARE = [
    ROLES_ID.SU_ADMIN,
    ROLES_ID.TECHNICIAN,
]

export const CHANGE_SIM_STATUS = [
    ROLES_ID.SU_ADMIN,
]

export const OPEN_FLASHING = [
    ROLES_ID.SU_ADMIN,
    ROLES_ID.INVENTORY,
]
export const CREATE_MC = [
    ROLES_ID.SU_ADMIN,
    ROLES_ID.INVENTORY,
]

export const AUTO_FLASHING = [
    ROLES_ID.SU_ADMIN,
    ROLES_ID.INVENTORY,
]

export const MANUAL_FLASHING = [
    ROLES_ID.SU_ADMIN,
    ROLES_ID.TECHNICIAN,
]
export const CONTROLLER_SCHEDULE_ROLES = [ROLES_ID.SU_ADMIN, ROLES_ID.ADMIN, ROLES_ID.TECHNICIAN, ROLES_ID.MANAGER, ROLES_ID.DEPARTMENT_MANAGER];
